import { format } from 'date-fns';
import type { GenerateStatementFormValues } from '../model';

const buildStatementParams = (data: GenerateStatementFormValues) => {
  const baseParams = {
    fileType: data.fileType,
    lang: data.lang,
  };

  const formatDate = (date: Date) => format(date, 'ddMMyyyy');

  if (data.datefilter && data.datefilter !== 'custom') {
    return {
      ...baseParams,
      datefilter: data.datefilter,
    };
  }

  if (data.datefilter === 'custom' && data.datefrom && data.dateto) {
    return {
      ...baseParams,
      datefrom: formatDate(data.datefrom),
      dateto: formatDate(data.dateto),
    };
  }

  return baseParams;
};

export { buildStatementParams };
